import React from 'react';
import Nav from './Nav';


const Header = () => (
  <header className="header">
    <Nav/>
  </header>
);


export default Header;